export default {
    'Change orientation': 'Orientierung ändern',
}